import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// For Show/Hide Password
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fullWidth: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreateEditAccount(props) {
  const classes = useStyles();

  const [isSavingSeller, setIsSavingSeller] = useState(false);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [isSavingSuccess, setIsSavingSuccess] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);

  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");

  const handlePasswordToggle = (value) => {
    if (value === "password") {
      setShowPassword(!showPassword);
    } else if (value === "retype_password") {
      setShowRetypePassword(!showRetypePassword);
    }
  };

  const [seller, setSeller] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    mobile_number: "",
    username: "",
    password: "",
    retype_password: "",
    user_type: 0,
  });

  const inputOnChangeListener = (event) => {
    const modifiedSeller = { ...seller };

    modifiedSeller[event.target.name] = event.target.value;
    setSeller(modifiedSeller);
  };

  useEffect(() => {}, [props.salesmanAction]);

  useEffect(() => {
    if (
      props.selectedSalesman === undefined ||
      props.selectedSalesman === null
    ) {
      return;
    }

    const edit_seller = { ...seller };

    edit_seller.first_name = props.selectedSalesman.first_name;
    edit_seller.last_name = props.selectedSalesman.last_name;
    edit_seller.middle_name = props.selectedSalesman.middle_name;
    edit_seller.mobile_number = props.selectedSalesman.mobile_number;
    edit_seller.username = props.selectedSalesman.username;
    edit_seller.user_id = props.selectedSalesman.id;
    edit_seller.user_type = props.selectedSalesman.type;
    setSeller(edit_seller);
  }, [props.selectedSalesman]);

  const saveSeller = (event) => {
    const newSellectAccount = { ...seller };
    setIsSavingSeller(true);
    const options = {
      method: "POST",
      url: "/TransactiSalesman/saveSalesman.json",
      data: objectToFormData(newSellectAccount),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          if (res.data.response.errors && res.data.response.errors[0]) {
            setMessageDialogMessage(res.data.response.errors[0]);
          } else {
            setMessageDialogMessage(res.data.response.message);
          }
          setIsSavingSuccess(false);
          setIsSavingSeller(false);

          setShowMessageDialog(true);

          return;
        }

        setIsSavingSuccess(true);
        setIsSavingSeller(false);
        setMessageDialogMessage("Seller save successfully.");
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingSeller(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const updateAccount = (event) => {
    const newSellectAccount = { ...seller };

    setIsSavingSeller(true);
    const options = {
      method: "POST",
      url: "/TransactiSalesman/updateSalesman.json",
      data: objectToFormData(newSellectAccount),
    };
    axios(options)
      .then((res) => {
        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          setIsSavingSuccess(false);
          setIsSavingSeller(false);
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);

          return;
        }

        setIsSavingSuccess(true);
        setIsSavingSeller(false);
        setMessageDialogMessage("Seller save successfully.");
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingSeller(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  function progressDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={isSavingSeller}
        onClose={() => {}}
      >
        <DialogContent>
          <DialogContentText>
            Saving account... Please wait...
          </DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }

  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);

              if (isSavingSuccess) {
                if (props.salesmanAction === "add") {
                  props.setSalesmanAction("add");
                } else {
                  props.setSalesmanAction("update");
                }

                props.setSelectedSalesman(null);
                props.setOpenCreateEditSalesman(false);
                props.reloadSalesmans();
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div>
      <Dialog
        fullScreen
        open={props.openCreateEditSalesman}
        onClose={() => {
          props.setSalesmanAction("add");
        }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                props.setSalesmanAction("add");
                props.setSelectedSalesman(null);
                props.setOpenCreateEditSalesman(false);
              }}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              {props.salesmanAction === "add"
                ? "Create Salesman"
                : "Update Salesman"}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <div style={{ padding: ".5rem" }}>
          <Grid container spacing={1}>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Grid item xs={12}>
                  First name*
                </Grid>
                <Grid item xs={12}>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={materialTheme}>
                      <form noValidate>
                        <TextField
                          autoComplete="off"
                          type="text"
                          className={classes.fullWidth}
                          value={seller.first_name}
                          name="first_name"
                          id="first-name"
                          rows={4}
                          variant="outlined"
                          onChange={inputOnChangeListener}
                        />
                      </form>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid item xs={12}>
                  Middle name
                </Grid>
                <Grid item xs={12}>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={materialTheme}>
                      <form noValidate>
                        <TextField
                          autoComplete="off"
                          className={classes.fullWidth}
                          value={seller.middle_name}
                          name="middle_name"
                          id="middle-name"
                          rows={4}
                          variant="outlined"
                          onChange={inputOnChangeListener}
                        />
                      </form>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid item xs={12}>
                  Last name*
                </Grid>
                <Grid item xs={12}>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={materialTheme}>
                      <form noValidate>
                        <TextField
                          autoComplete="off"
                          className={classes.fullWidth}
                          value={seller.last_name}
                          name="last_name"
                          id="last-name"
                          rows={4}
                          variant="outlined"
                          onChange={inputOnChangeListener}
                        />
                      </form>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              Contact Number*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <form noValidate>
                    <TextField
                      className={classes.fullWidth}
                      value={seller.mobile_number}
                      name="mobile_number"
                      id="mobile_number"
                      rows={4}
                      variant="outlined"
                      onChange={inputOnChangeListener}
                    />
                  </form>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item xs={12}>
              Username*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <form noValidate>
                    <TextField
                      className={classes.fullWidth}
                      value={seller.username}
                      name="username"
                      id="username"
                      rows={4}
                      variant="outlined"
                      onChange={inputOnChangeListener}
                      disabled={props.salesmanAction === "add" ? false : true}
                    />
                  </form>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            {/* <Grid item xs={12} >Transacti User Type</Grid>
                <Grid item xs={12}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                             <form noValidate>
                                <Select
                                    className={classes.fullWidth}
                                    name="user_type"
                                    id="user_type"
                                    value={seller.user_type}
                                    onChange={inputOnChangeListener}
                                    rows={4}
                                    variant="outlined"
                                >
                                    <MenuItem value={0}>Booking</MenuItem>
                                    <MenuItem value={1}>Van/Delivery</MenuItem>
                                    <MenuItem value={2}>Teleseller</MenuItem>
                                </Select>
                            </form>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid> */}

            <Grid item xs={12}>
              Password*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <form noValidate>
                    <TextField
                      className={classes.fullWidth}
                      value={seller.contact_number}
                      name="password"
                      id="password"
                      rows={4}
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      onChange={inputOnChangeListener}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              name="passwordViewer"
                              onClick={() => handlePasswordToggle("password")}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </form>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item xs={12}>
              Re-type Password*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <form noValidate>
                    <TextField
                      className={classes.fullWidth}
                      value={seller.contact_number}
                      name="retype_password"
                      id="retype_password"
                      rows={4}
                      type={showRetypePassword ? "text" : "password"}
                      variant="outlined"
                      onChange={inputOnChangeListener}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              name="passwordViewer"
                              onClick={() =>
                                handlePasswordToggle("retype_password")
                              }
                            >
                              {showRetypePassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </form>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item container>
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                onClick={
                  props.salesmanAction === "add" ? saveSeller : updateAccount
                }
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {progressDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default CreateEditAccount;
